<template>
    <div class="container">
        <WorkloadSection />
        <div class="content-panel">
            <NavigationPanel :type="type" @type="changeType" />

            <div class="users-list">
                <div>
                    <!-- row with sort and search input -->
                    <SortPanel :type="type" @search="(v) => (search = v)" @sort="(v) => (sort = v)" />
                </div>
                <div>
                    <!-- aside filters -->
                    <!-- <FiltersAside /> -->
                </div>

                <!-- grid -->
                <div class="container">
                    <template v-if="loading">
                        <div class="loader loader--chat loader--grey-background">
                            <i class="fa fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></i>
                        </div>
                    </template>

                    <template v-for="coach in filteredCoaches" v-else>
                        <div :key="coach.id" class="user-wrapper panel">
                            <a
                                :href="`/terapeut/${coach.id}`"
                                :class="{ disabled: !isRegistered(coach) || type === 'archived' }"
                            >
                                <div class="user-wrapper-top">
                                    <span v-if="coach.is_substitute" class="user-notification substitute">
                                        {{ __('Substitute for holiday until') }} {{ moment(coach.substitute.end_date).format('D. M. YYYY') }}
                                    </span>

                                    <span v-if="coach.has_vacation" class="user-notification vacation">
                                        {{ __('Holiday to') }} {{ moment(coach.vacation.end_date).format('D. M. YYYY') }}
                                    </span>

                                    <span v-if="!isRegistered(coach)" class="user-notification not-registered">
                                        <template>{{ __('The dietitian still hasn\'t completed registration.') }}</template>
                                    </span>

                                    <UserAvatar :user-info="coach.user" size="lg" />

                                    <div class="profile-information">
                                        <h1 class="user-name">{{ coach.user | fullname }}</h1>

                                        <span>
                                            {{ __('Start at') }} {{ moment(coach.start_date).format('D. MMMM YYYY') }}
                                        </span>
                                        <a :href="`mailto:${coach.user.email}`" class="mail">
                                            <strong>{{ coach.user.email }}</strong>
                                        </a>

                                        <strong>{{ coach.phone_international }}</strong>

                                        <input
                                            :id="'accepts_new_patients-' + coach.id"
                                            class="input-checkbox checkbox-toggle"
                                            type="checkbox"
                                            :checked="coach.accepts_new_patients"
                                        />
                                        <label
                                            :for="'accepts_new_patients-' + coach.id"
                                            class="label-checkbox label-toggle"
                                            @click="changePatientAcceptation(coach.id)"
                                        >
                                            {{ __('Recruitment of new patients') }}
                                        </label>
                                    </div>
                                </div>
                            </a>

                            <div class="user-information">
                                <div class="user-data">
                                    <div class="user-box-date">
                                        <figure>
                                            <svg-icon icon="graph-up" />
                                        </figure>
                                        <strong>{{ coach.patients_in_intensive_phase_count || '-' }}</strong>
                                    </div>

                                    <div class="user-box-date">
                                        <figure>
                                            <svg-icon icon="graph-right" />
                                        </figure>
                                        <strong>{{ coach.patients_in_sustain_phase_count || '-' }}</strong>
                                    </div>

                                    <div class="user-box-date">
                                        <figure>
                                            <svg-icon icon="calendar-alternative" />
                                        </figure>
                                        <strong>{{ numberFormat(coach.month_opening_hours_duration, 1) }} h/m</strong>
                                    </div>
                                </div>

                                <!-- TODO indicator and loading data -->
                                <div class="user-time">
                                    <div
                                        :class="
                                            'transparent-indicator-grey'
                                        "
                                        class="user-box-time"
                                    >
                                        <span>{{ __('Feedback') }}</span>
                                        <p>-</p>
                                    </div>

                                    <div
                                        :class="'transparent-indicator-' + coach.consultation_rating_call_color"
                                        class="user-box-time"
                                    >
                                        <span>{{ __('CSAT (call)') }}</span>
                                        <p :class="'indicator-' + coach.consultation_rating_call_color">
                                            {{
                                                coach.consultation_rating_call
                                                    ? coach.consultation_rating_call + '%'
                                                    : '-'
                                            }}
                                        </p>
                                    </div>

                                    <div
                                        :class="
                                            'transparent-indicator-' + coach.consultation_rating_after_3_months_color
                                        "
                                        class="user-box-time"
                                    >
                                        <span>{{ __('CSAT (3m)') }}</span>
                                        <p :class="'indicator-' + coach.consultation_rating_after_3_months_color">
                                            {{
                                                coach.consultation_rating_after_3_months
                                                    ? coach.consultation_rating_after_3_months + '%'
                                                    : '-'
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <FlashAlert v-if="showAlert" :level="alertLevel" :text="alertMsg" @closeAlert="close()" />
    </div>
</template>

<script>
import NavigationPanel from './NavigationPanel.vue'
// import FiltersAside from './FiltersAside.vue'
import SortPanel from './SortPanel.vue'
import WorkloadSection from './WorkloadCalendar/WorkloadSection.vue'
import FlashAlert from '@components/FlashAlert'

export default {
    components: {
        FlashAlert,
        NavigationPanel,
        // FiltersAside,
        SortPanel,
        WorkloadSection
    },
    data() {
        return {
            coaches: [],
            sort: 'newest',
            search: '',
            sortMap: {
                newest: ['created_at'],
                oldest: ['created_at', 'asc'],
                vacation: ['has_vacation'],
                substitute: ['is_substitute']
            },
            openingHoursDuration: 0,
            showAlert: false,
            alertLevel: null,
            alertMsg: null,
            type: 'active',
            loading: false
        }
    },
    computed: {
        filteredCoaches() {
            // used for sorting
            const filters = [{ name: 'user.fullname' }]

            // create a collection of coaches
            let coaches = this.collect(this.coaches, { filters })

            // sort
            coaches = coaches.orderBy(...this.sortMap[this.sort])

            // search
            coaches = coaches.search(this.search)

            // return filtered and ordered collection of coaches
            return coaches.all()
        }
    },
    async mounted() {
        $('.item-therapist').addClass('active')
        const uri = new URI(location.href)

        if (uri.hasQuery('type')) {
            this.changeType(uri.search(true).type)
        } else {
            this.fetch()
        }
    },
    methods: {
        fetch() {
            axios.get(`/coaches/${this.type}`).then((response) => {
                this.coaches = response.data.data
                this.loading = false
            })
        },
        changePatientAcceptation(id) {
            const acceptsNewPatients = $('#accepts_new_patients-' + id).prop('checked')

            if (!acceptsNewPatients === true) {
                this.alertLevel = 'success'
                this.alertMsg = lang.get('Recruitment of new patients is activated.')
            } else {
                this.alertLevel = 'danger'
                this.alertMsg = lang.get('Recruitment of new patients is deactivated.')
            }

            this.showAlert = true

            axios
                .post(`/coaches/${id}/accepts-new-patients`, {
                    accepts_new_patients: !acceptsNewPatients
                })
                .catch((e) => {
                    console.log(e.response)
                })
        },
        close() {
            this.showAlert = false
        },
        isRegistered(coach) {
            if (coach.invitation && coach.invitation.used_at === null) {
                return false
            } else {
                return true
            }
        },
        changeType(type) {
            this.type = type
            this.loading = true
            this.fetch()
        }
    }
}
</script>
